import {
  SUPER_SYSTEM_PLAYED_COUPONS_REQUEST,
  SUPER_SYSTEM_PLAYED_COUPONS_SUCCESS,
  SUPER_SYSTEM_PLAYED_COUPONS_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  let playedCouponCount;

  switch (action.type) {
    case SUPER_SYSTEM_PLAYED_COUPONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SUPER_SYSTEM_PLAYED_COUPONS_SUCCESS:

      playedCouponCount = action.payload.filter(item => item.isAllPlayed || item.isPartiallyPlayed ).reduce((prev, curr) => {
        return prev + curr.playedCouponCount;
      }, 0);

      return { ...state, data: action.payload, playedCouponCount, isLoading: false, error: null };
    case SUPER_SYSTEM_PLAYED_COUPONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
